import React, {useEffect, useState} from 'react';
import { Accordion, Toggle } from '../../../../components';
import {useCurrentUser} from "../../../../contexts/UserContext";
import { useViewerStore} from "../../../../store/store";
import {Button, Select} from 'antd';
import MoveModuleByMeasurement from "../../../../components/Layout-Components/Editor-Layout/Modal/Modal-Content/MoveModuleByMeasurement";
import ModuleEditOptionsSection from "./ModuleEditOptionsSection";
import {
    ArrowsClockwiseIcon,
    BoundingBoxIcon,
    CheckCircleIcon,
    EraserIcon,
    RulerIcon
} from "@phosphor-icons/react";
import {MdOutlineCropLandscape, MdOutlineCropPortrait, MdTextRotationAngleup} from "react-icons/md";
import {BsGrid1X2} from "react-icons/bs";

import {
    SetDisplayShadePoints
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/RefreshShade";
import {
    GetSelModules,
    ResetSelModuleArr,
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/ModuleControl";
import TotalSystemEfficiency
    from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/TotalSystemEfficiency";
import RoofInformationTable
    from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/RoofInformationTable";
import { LAYER_OPTIONS } from '../../../../Constants';
import {
    OverrideSetbackDepthTo36, UpdateSetbackDepth
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/PathwayControl";
import {
    deActivateRoof, ifRoofDeactivated, reActivateRoof,
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Common";
import { toggleLayer } from '../../../../helpers/storeHelpers';
import { ModuleMesh, RoofMesh } from '../../../../@types/types';import { AlertType, HideObjectType, ModuleOrientation, SelectType, EditAction } from '../../../../@types/enums';
import ModuleTypeChangeConfirm
    from "../../../../components/Layout-Components/Editor-Layout/Modal/Modal-Content/ModuleTypeChangeConfirm";
import RackingEditOptionSection from './RackingEditOptionSection';
import { isGroundMount } from '../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/PlaneRoofControls';

const ModuleProperties: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const { hasCapability, user } = useCurrentUser();
    const manualZone = useViewerStore((state) => state.manualZone)
    const moduleList = useViewerStore((state) => state.moduleList);
    const isRoofTagVisible = useViewerStore((state) => state.isRoofTagVisible)
    const isModuleMultiplierLabelVisible = useViewerStore((state) => state.isModuleMultiplierLabelVisible)
    const layerVisibilityState = useViewerStore((state) => state.layerVisibilityState)
    const isSetbackOverride = useViewerStore((state) => state.isSetbackOverride)
    const activeModule = useViewerStore((state) => state.activeModule);
    const [selectedRoofStatus, setSelectedRoofStatus] = useState(false);
    const moduleSolarAccess = useViewerStore(state => state.moduleSolarAccess);
    const selRoofFaceArr = useViewerStore(state => state.selRoofFaceArr);
    const modeCount = useViewerStore(state => state.modeCount);
    const isMoveModuleActive = useViewerStore((state) => state.isMoveModuleActive)
    const [showBallastRackAccordian, setShowBallastRackAccordian] = useState(false);
    const pathname = useViewerStore(state => state.pathname);

    const moduleListSorted = moduleList.filter(m => m.w !== 0 && m.h !== 0);
    moduleListSorted.sort((a, b) => a.text.localeCompare(b.text));

    const antdCompatiableModuleList = moduleListSorted.map(m => ({text: m.text, value: m.text}));

    // const {selRoofFaceArr} = useViewerStore();
    const isBoxSelectMode = useViewerStore(state => state.isBoxSelectMode);

    useEffect(() => {
        sceneViewer?.hideObject(HideObjectType.ModuleTexture, moduleSolarAccess);
    }, [sceneViewer, moduleSolarAccess]);

    useEffect(() => {
        if(!selRoofFaceArr || selRoofFaceArr.length === 0) {
            setShowBallastRackAccordian(false);
            setSelectedRoofStatus(false);
            return;
        }
        const isRoofDeactivated = ifRoofDeactivated(selRoofFaceArr[0].userData.roof_tag_id);
        setSelectedRoofStatus(isRoofDeactivated);

        if (selRoofFaceArr[0].userData.pitchOverride < 5.1 && !isGroundMount(selRoofFaceArr[0])) {

            //get selected modules
            const selModules = GetSelModules(sceneViewer.moduleMeshArr);

            if (selModules.length === 0) {
                sceneViewer.viewerAlert({
                    show: true,
                    title: 'Flat Roof Selected',
                    message: "Selected Roof has a pitch of less than 5 degrees, Ballasted Racking recommended",
                    messageType: AlertType.info,
                    isCloseAfterDisplay: true,
                    autoCloseSeconds: 3000,
                })
            }
            setShowBallastRackAccordian(true);
        } else {
            setShowBallastRackAccordian(false);
        }
    }, [selRoofFaceArr, pathname]);




    const selectModule = (e: string) => {
        if (manualZone) return;
        const {moveMode} = sceneViewer;
        if (moveMode) return;

        const selModule: any = moduleList.find(item => item.text === e);
        if (selModule === -1) {
            return;
        }

        sceneViewer.viewerAlert({
            show: true,
            title: "Confirm Module Type Change",
            message: <ModuleTypeChangeConfirm selModule={selModule} />,
            messageType: AlertType.info,
            isModal: true
        })



    }

    const handleMoveModuleByMeasurement = () => {
        //check if module is selected
        //if not selected show alert
        const selModules = GetSelModules(sceneViewer.moduleMeshArr);
        if (!selModules || !selModules.length) {
            alert("Please select a module to move by measurement")
        } else {
            sceneViewer.viewerAlert({
                show: true,
                title: "Move Module by Measurement",
                message: <MoveModuleByMeasurement/>,
                messageType: AlertType.info,
                isModal: true
            })
        }
    }

    const setBoxSelectMode = () => {
        ResetSelModuleArr(sceneViewer.moduleMeshArr);
        if(isBoxSelectMode) {
            sceneViewer.removeSelectionBoxHelper();
        } else {
            sceneViewer.selectType = SelectType.module;
            sceneViewer.setupSelectionBoxHelper(SelectType.module);
        }
    }

    const toggleRoofTag = () => {
        sceneViewer.toggleRoofTag(!isRoofTagVisible);
        useViewerStore.setState({isRoofTagVisible: !isRoofTagVisible});
    }

    const toggleModuleMultiplier = () => {
        useViewerStore.setState({isModuleMultiplierLabelVisible: !isModuleMultiplierLabelVisible});
        sceneViewer.toggleModuleMultiplierLabel(!isModuleMultiplierLabelVisible);
    }

    const spinAllModules = () => {
        sceneViewer.spinAllModules();
    }

    const clearModule = (selFace: RoofMesh) => {
        const {moduleCount, roofFaceId} = selFace;
        if (!moduleCount) return;
        sceneViewer.setClearFaceModule(selFace);
        const cloneFaceArr = [...selRoofFaceArr];
        cloneFaceArr.forEach(face => {
            if (face.roofFaceId === roofFaceId) face.moduleCount = 0;
        });
        useViewerStore.setState({selRoofFaceArr: cloneFaceArr});
    }

    const autoFillHandler = (direction: ModuleOrientation) => {
        sceneViewer.setRoofModuleDir(direction);
    }


    const toggleSetbackOverride = () => {
        useViewerStore.setState({isSetbackOverride: !isSetbackOverride});
    }

    const deactivateRoofHandler = () => {
        const currentSelectedRoof = useViewerStore.getState().selRoofFaceArr[0];
        if (ifRoofDeactivated(currentSelectedRoof.userData.roof_tag_id)) {
            reActivateRoof(currentSelectedRoof)
        }
        else {
            deActivateRoof(currentSelectedRoof)
        }
    }

    
    useEffect(() => {
        if(!sceneViewer) return;
        if (isSetbackOverride) {
            OverrideSetbackDepthTo36(sceneViewer)
        }
        else{
            if(modeCount > 0){
                UpdateSetbackDepth(sceneViewer,);
            }
        }

    },[isSetbackOverride,modeCount])


    const rackingOptions = [
        {value: '10', text: '10°'},
    ]


    const handleRemoveModule = (e: React.MouseEvent<HTMLElement>) => {
        if (manualZone) return;
        const target = e.target as HTMLElement;
        if (target.classList.contains('disabled')) return;
        const selModules = GetSelModules(sceneViewer.moduleMeshArr);
        if (!selModules || !selModules.length) {
            sceneViewer.viewerAlert({
                title: 'Please select modules to delete',
                messageType: AlertType.warning,
                isCloseAfterDisplay: true,
                autoCloseSeconds: 2000,
            });
            return;
        }
        sceneViewer.setModuleSetting('delete');
    }

    const handleMoveModule = (e: React.MouseEvent<HTMLElement>) => {
        if (manualZone) return;
        sceneViewer.selectType = SelectType.module;
        const target = e.target as HTMLElement;
        if (target.classList.contains('disabled')) return;
        useViewerStore.setState({isMoveModuleActive: !isMoveModuleActive, isAddModuleActive: false,isBallastedRackTypeModuleActive: false})
        if (!isMoveModuleActive) {
            sceneViewer.setPushMode(false);
            //Check if module is selected
            const selModules = GetSelModules(sceneViewer.moduleMeshArr);
            if (!selModules || !selModules.length) {
                sceneViewer.viewerAlert({
                    title: 'Please select modules to move',
                    messageType: AlertType.warning,
                    isCloseAfterDisplay: true,
                    autoCloseSeconds: 2000,
                });
                useViewerStore.setState({isMoveModuleActive: false})
                sceneViewer.setMoveMode(false);
                return;
            }

            // Prevent moving multiple Ballasted Racking modules at once
            const selectedBallastedRacks = selModules.filter((module: ModuleMesh) => module.userData?.isBallastedRackType === true);
            if (selectedBallastedRacks.length > 1) {
                sceneViewer.viewerAlert({
                    title: 'Cannot Move Multiple Ballasted Rack Modules',
                    message: "Please select only one Ballasted Rack module to move at a time.",
                    messageType: AlertType.warning,
                    isCloseAfterDisplay: true,
                    autoCloseSeconds: 2000,
                });
                useViewerStore.setState({isMoveModuleActive: false});
                sceneViewer.setMoveMode(false);
                return;
            }

            document.body.style.cursor = "move";
            sceneViewer.setMoveMode(true);
        } else {
            sceneViewer.setMoveMode(false);
            document.body.style.cursor = "default";
            ResetSelModuleArr(sceneViewer.moduleMeshArr);
        }
    }



    return (
        <>
            <div className='tab__inner'>
                {!showBallastRackAccordian && <ModuleEditOptionsSection 
                    handleRemoveModule={handleRemoveModule} 
                    handleMoveModule={handleMoveModule}/>}
                <div className='tab__column'>
                    <Accordion title='Show/Hide System Information' active={false}>
                        <div className='tab__column' style={{ paddingTop: '0px', paddingLeft: '8px', paddingRight: '8px' }}>
                            <span className='tab__column--title' style={{ marginBottom: '0px' }}>Total System Efficiency</span>
                            <TotalSystemEfficiency popoutVersion={false} />
                            <span className='tab__column--title' style={{ position: "relative", marginBottom: '2px' }}>Roof Information Table</span>
                            <RoofInformationTable shortened={true} />
                        </div>
                    </Accordion>
                </div>

                {hasCapability('Edit_Module_Type') && showBallastRackAccordian &&
                    <RackingEditOptionSection 
                        handleRemoveModule={handleRemoveModule} 
                        handleMoveModule={handleMoveModule} />
                }

                {hasCapability('Edit_Module_Type') &&
                    <>
                        <div className={`tab__column ${manualZone ? 'disabled' : ''}`}>
                            <span className='tab__column--title'>Module Type</span>
                            {
                                <Select
                                    placeholder='Select Module Type'
                                    style={{width: '100%', fontSize: '11px'}}
                                    value={activeModule?.text ?? ''}
                                    showSearch={true}
                                    onChange={selectModule}
                                    onFocus={() => {
                                        useViewerStore.setState({isTypeEvent: true});
                                    }}
                                    onBlur={() => {
                                        useViewerStore.setState({isTypeEvent: false});
                                    }}
                                    options={antdCompatiableModuleList}
                                />
                            }
                        </div>
                    </>
                }

                <div className={`tab__column`}>
                    <div className='btn-module'>
                        <div className='w-half'>
                            <Button
                                icon={<RulerIcon size={16}/>}
                                className='font-sm'
                                size='middle'
                                onClick={handleMoveModuleByMeasurement}>Measurement Move</Button>
                        </div>
                        <div className='w-half'>
                            <Button
                                icon={<BoundingBoxIcon size={18}/>}
                                className={`font-sm ${isBoxSelectMode ? 'active' : ''}`} size='middle'
                                onClick={setBoxSelectMode}
                            >Box Select Mode</Button>
                        </div>
                        <div className={`w-half ${selRoofFaceArr ? 'center' : ''}`}>
                            <Button
                                icon={<ArrowsClockwiseIcon size={18}/>}
                                className='font-sm'
                                id='spinAllModulesBtn' type='default' size='middle'
                                onClick={spinAllModules}
                            >Rotate All Panels</Button>
                        </div>
                        {selRoofFaceArr.map((item, idx) => {
                            return (
                                <React.Fragment key={item?.uuid ?? item?.userData?.roof_tag_id ?? idx}>
                                    {hasCapability('Edit_Module_Remove') &&
                                        <div className='w-half'>
                                            <Button
                                                icon={<EraserIcon size={18} />}
                                                className='font-sm'
                                                type='default' size='middle'
                                                onClick={() => clearModule(item)}>
                                                Clear Roof Layout
                                            </Button>
                                        </div>
                                    }
                                    <div className='w-half'>
                                            <Button
                                                icon={<CheckCircleIcon size={18}/>}
                                                size='middle'
                                                className='font-sm'
                                                onClick={deactivateRoofHandler}>
                                                {
                                                    selectedRoofStatus ? <span className={"deactive-roof-context-menu-enable-text"}>Activate Roof</span> : <span className={"deactive-roof-context-menu-disable-text"}>Deactivate Roof</span>
                                                }
                                            </Button>
                                    </div>
                                    <div className='w-half'>
                                        <Button
                                            icon={<MdOutlineCropPortrait size={20} />}
                                            size='middle'
                                            className='font-sm'
                                            onClick={() => autoFillHandler(ModuleOrientation.Portrait)}>
                                            Autofill Portrait
                                        </Button>
                                    </div>
                                    <div className='w-half'>
                                        <Button
                                            icon={<MdOutlineCropLandscape size={20} />}
                                            size='middle'
                                            className='font-sm'
                                            onClick={() => autoFillHandler(ModuleOrientation.Landscape)}>
                                            Autofill Landscape
                                        </Button>
                                    </div>
                                    <div className='w-half'>
                                        <Button
                                            icon={<BsGrid1X2 size={18} />}
                                            size='middle'
                                            className='font-sm'
                                            onClick={() => autoFillHandler(ModuleOrientation.Both)}>
                                            Autofill Both
                                        </Button>
                                    </div>
                                </React.Fragment>
                            )
                        })}
                    </div>
                </div>
                <div className='tab__column'>
                    <div className='tab__flex justify-between'>
                        <span className='tab__column--subtitle mb-0'>Module Solar Access</span>
                        <Toggle
                            id={"hideModuleTexture"}
                            on={moduleSolarAccess}
                            onChange={(value: boolean) => {
                                useViewerStore.setState({moduleSolarAccess: value});
                                SetDisplayShadePoints(sceneViewer, value ? "module" : undefined);
                                toggleLayer(LAYER_OPTIONS.SYSTEM.IRRADIANCE, value)
                            }}
                            property='ModuleTexture'
                        ></Toggle>
                    </div>
                    <br/>
                    <div className='tab__flex justify-between'>
                        <span className='tab__column--subtitle mb-0'>Show/Hide Roof Tag</span>
                        <Toggle
                            on={isRoofTagVisible}
                            onChange={toggleRoofTag}
                        />
                    </div>
                    <br/>

                    {

                        user && (user.application_role_name == "Sales Ops" || user.application_role_name == "RSA" || user.application_role_name=="Admin") &&

                        <>
                            <div className='tab__flex justify-between'>
                                <span className='tab__column--subtitle mb-0'>Enforce 33% Rule (Add On Only)</span>
                                <Toggle
                                    on={isSetbackOverride}
                                    onChange={toggleSetbackOverride}
                                />
                            </div>
                            <br/>
                        </>

                    }

                    {hasCapability('Modules_Multipliers') &&
                        <div className='tab__flex justify-between'>
                            <span className='tab__column--subtitle mb-0'>Show Module Multipliers</span>
                            <Toggle
                                on={isModuleMultiplierLabelVisible}
                                onChange={toggleModuleMultiplier}
                                disabled={!layerVisibilityState.modules || !layerVisibilityState.roof}
                            />
                        </div>
                    }

                </div>

            </div>
        </>
    );
}

export default ModuleProperties;
